// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const Accordions = t.struct({
    amountOfUseIsExpanded: t.Bool,
    baseMachineComponentsIsExpanded: t.Bool,
    componentsIsExpanded: t.Bool,
    externalNotesIsExpanded: t.Bool,
    incentiveProgransIsExpanded: t.Bool,
    internalNotesIsExpanded: t.Bool,
    maintenancePlanIsExpanded: t.Bool,
    optionCodesIsExpanded: t.Bool,
    pastClaimsIsExpanded: t.Bool,
    pipHistoryIsExpanded: t.Bool,
    registrationHistoryIsExpanded: t.Bool
}, 'Accordions');

export const getDefaultState = () => new Accordions({
    amountOfUseIsExpanded: false,
    baseMachineComponentsIsExpanded: false,
    componentsIsExpanded: false,
    externalNotesIsExpanded: true,
    incentiveProgransIsExpanded: false,
    internalNotesIsExpanded: true,
    maintenancePlanIsExpanded: false,
    optionCodesIsExpanded: false,
    pastClaimsIsExpanded: false,
    pipHistoryIsExpanded: false,
    registrationHistoryIsExpanded: false
});

export default Accordions;



// WEBPACK FOOTER //
// ./src/product/details/state/accordions.js